export const BanIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456726 3.7039C0.00259972 4.80026 -0.11622 6.00666 0.115291 7.17054C0.346802 8.33443 0.918247 9.40353 1.75736 10.2426C2.59648 11.0818 3.66558 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0892 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C11.9983 4.40923 11.3656 2.88411 10.2407 1.75926C9.1159 0.634414 7.59077 0.00172054 6 0V0ZM6 1C7.15324 0.99908 8.27097 1.39888 9.162 2.131L2.131 9.162C1.53129 8.42992 1.15183 7.54256 1.03681 6.60321C0.92179 5.66387 1.07593 4.71117 1.4813 3.85602C1.88666 3.00087 2.52657 2.27844 3.32654 1.77282C4.12651 1.2672 5.05364 0.999199 6 1V1ZM6 11C4.84677 11.0009 3.72904 10.6011 2.838 9.869L9.869 2.838C10.4687 3.57008 10.8482 4.45744 10.9632 5.39679C11.0782 6.33613 10.9241 7.28883 10.5187 8.14398C10.1133 8.99913 9.47344 9.72156 8.67346 10.2272C7.87349 10.7328 6.94637 11.0008 6 11Z"
      fill="currentColor"
    />
  </svg>
);
